import { routePaths } from "@/App";
import { Button } from "@/components/ui/button";
import { VehicleType } from "@/libs/api/types";
import { cn } from "@/utils/cn";
import { IconCheck, IconRoute } from "@tabler/icons-react";
import { ChevronLeft, MapPin, Package } from "lucide-react";
import { Link, Navigate, useNavigate } from "react-router";
import { useTourStop } from "../hooks/useTourStop";

import { useTourNavigation } from "../hooks/useTourNavigation";
import { useTranslation } from "react-i18next";
import { TourTaskItem } from "../components/TourTaskItem";
import { openNavigationApp } from "../utils/navigation";
import { NavigationSelect } from "@/components/NavigationSelect";

interface DropOffViewProps {
  tourId: string;
  stopId: string;
}

export function DropOffView({ stopId, tourId }: DropOffViewProps) {
  const { t } = useTranslation();

  const { currentStop, handleGatherDropOff } = useTourStop(stopId);

  const { navigateToNextStop } = useTourNavigation(currentStop);

  const navigate = useNavigate();

  if (!currentStop) {
    return <Navigate to={routePaths.createTourPath(tourId)} />;
  }

  return (
    <div className="h-screen">
      <div className="h-full flex flex-col ">
        <header className="bg-white px-4 py-6 pt-safe border-b-2 border-neutral">
          <Link
            to={routePaths.createTourPath(tourId)}
            className="mb-8 flex items-center font-medium gap-1.5 bg-slate-100 w-fit p-2 pr-4 rounded"
          >
            <ChevronLeft className="w-5 h-5" strokeWidth={2.5} />
            {t("common.back")}
          </Link>

          <h3 className="text-xl font-semibold mb-2">
            {t("gatherDropoff.header.title")}
          </h3>

          <div className="flex items-center text-sm font-medium text-[#6A80A8]">
            <MapPin className="w-5 h-5 mr-2" strokeWidth={2.5} />
            {currentStop.address}
          </div>

          <NavigationSelect
            address={currentStop.address}
            vehicle={VehicleType.CAR}
          />
        </header>

        <div className="p-4 h-full space-y-4 overflow-y-scroll flex-1 bg-slate-100">
          {currentStop?.items.map((item) => (
            <TourTaskItem
              key={item.id}
              item={item}
              onClick={() => {
                navigate(
                  `/tour/${tourId}/gatherTask-dropOff/${stopId}/${item.id}`,
                );
              }}
            />
          ))}
        </div>

        <div className="bg-white p-4 border-t-2 border-neutral pb-safe">
          <Button
            className="w-full"
            variant="secondary"
            onClick={navigateToNextStop}
          >
            {t("common.nextStop")}
          </Button>
        </div>
      </div>
    </div>
  );
}
